import {LayoutButton} from "./LayoutButton";

export class PuppetGameButton extends LayoutButton {

    public getOnboardingPosition(): PIXI.Point {
        const p = super.getOnboardingPosition();
        p.y -= this._visuals.height * 0.4;
        return p;
    }

    public getFocusSize(): PIXI.Point {
        const p = super.getFocusSize();
        p.x *= 0.5;
        p.y *= 0.5;
        return p;
    }

    protected playHoverVO(): void {
        // Can play on top of fact VO
        this._canPlayVo = true;
        super.playHoverVO();
        if (this._hoverVO !== undefined && this._canPlayVo) {
            this._hoverVO = undefined;
        }
    }
}
